import React from 'react';
import styled, { css } from 'styled-components';
import { appConfig } from 'config/app';
import { theme, toRem } from 'design';
import { AuthService } from 'lib';
import { Text } from '../Typography';

const Layout = styled.footer`
  display: flex;
  flex-shrink: 0;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  padding: ${toRem(32)} ${toRem(theme.layout.gutter.small)} ${toRem(12)};

  @media (min-width: ${theme.breakpoint.small}px) {
    flex-flow: row nowrap;
    justify-content: space-between;
    height: ${toRem(66)};
    padding: 0 ${toRem(theme.layout.gutter.large)};
    border-top: ${toRem(1)} solid ${theme.color.neutral[200]};
  }
`;

const TextStyles = css`
  font-size: ${toRem(11)};
  line-height: 100%;
  text-align: center;
  text-decoration: none;
  color: ${theme.color.neutral[700]};

  @media (min-width: ${theme.breakpoint.small}px) {
    font-size: ${toRem(13.25)};
  }
`;

const Nav = styled.nav`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: ${toRem(11)};

  @media (min-width: ${theme.breakpoint.small}px) {
    flex-flow: row nowrap;
    width: auto;
    margin-bottom: 0;
  }

  a {
    margin-right: ${toRem(11)};
    ${TextStyles}
    transition: ${theme.transition.button.fast};

    &:visited,
    &:active {
      color: ${theme.color.neutral[700]};
    }

    &:hover {
      color: ${theme.color.neutral[800]};
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

const Copyright = styled(Text).attrs({ size: 'small' })`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${TextStyles}

  @media (min-width: ${theme.breakpoint.small}px) {
    width: auto;
  }
`;

const Footer = () => {
  const isSalesforceSupport = process.env.REACT_APP_SALESFORCE_SUPPORT;
  const isSalesforceSSOBaseUrl = process.env.REACT_APP_SALESFORCE_SSO_BASE_URL;
  const jwt = AuthService.getToken();

  return (
    <Layout>
      <Nav>
        <Text as="a" href={appConfig.LINKS.TERMS_OF_USE} rel="noopener noreferrer" size="small" target="_blank">
          Terms Of Use
        </Text>

        <Text as="a" href={appConfig.LINKS.PRIVACY_POLICY} rel="noopener noreferrer" size="small" target="_blank">
          Privacy Policy
        </Text>

        {isSalesforceSupport && isSalesforceSSOBaseUrl && jwt ? (
          <Text as="a" href={`${isSalesforceSSOBaseUrl}?jwt=${jwt}`} rel="noopener noreferrer" size="small" target="_blank">
            Support
          </Text>
        ) : (
          <Text as="a" href={appConfig.LINKS.SUPPORT} rel="noopener noreferrer" size="small" target="_blank">
            Support
          </Text>
        )}
      </Nav>
      <Copyright>{`© ${new Date().getFullYear()} Kickfin. All rights reserved.`}</Copyright>
    </Layout>
  );
};

export default Footer;
